<template>
  <b-container class="vh-100 d-flex align-items-center justify-content-center">
    <b-card style="width: 100%; max-width: 450px; border-radius: 15px;" class="shadow border-0">
      <h3 class="text-center mb-4 font-weight-bold">회원 등록 (관리자)</h3>
      <b-form @submit.prevent="handleRegister">
        <b-form-group label="아이디">
          <b-form-input v-model="form.username" required placeholder="아이디를 입력하세요"></b-form-input>
        </b-form-group>

        <b-form-group label="이름">
          <b-form-input v-model="form.name" required placeholder="성함을 입력하세요"></b-form-input>
        </b-form-group>

        <b-form-group label="비밀번호">
          <b-form-input v-model="form.password" type="password" required placeholder="비밀번호를 입력하세요"></b-form-input>
        </b-form-group>

        <b-form-group label="비밀번호 확인">
          <b-form-input
              v-model="passwordConfirm"
              type="password"
              required
              placeholder="비밀번호를 한 번 더 입력하세요"
              :state="passwordState"
          ></b-form-input>
          <b-form-invalid-feedback :state="passwordState">
            비밀번호가 일치하지 않습니다.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button type="submit" variant="primary" block class="mt-4" :disabled="!passwordState">등록하기</b-button>
        <div class="text-center mt-3">
          <b-button variant="link" size="sm" @click="$router.push('/')">취소하고 메인으로</b-button>
        </div>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>

export default {
  data() {
    return {
      form: {
        username: '',
        name: '',
        password: '',
        groupType: 'user',        // 기본값 세팅
        passwordReset: 1          // 기본값 세팅
      },
      passwordConfirm: ''
    };
  },
  computed: {
    // 비밀번호 일치 여부 확인 (Bootstrap Vue 상태값)
    passwordState() {
      if (this.passwordConfirm.length === 0) return null;
      return this.form.password === this.passwordConfirm;
    }
  },
  created() {
    // [권한 체크] admin이 아니면 접근 차단
    // this.checkAdminAuth();
  },
  methods: {
    checkAdminAuth() {
      // 로컬 스토리지나 Vuex에 저장된 유저 정보를 확인
      const userData = JSON.parse(localStorage.getItem('user')); // 로그인 시 저장한 데이터 기준
      if (!userData || userData !== 'admin') {
        alert('관리자만 접근 가능한 페이지입니다.');
        this.$router.push('/');
      }
    },
    async handleRegister() {
      if (!this.passwordState) {
        alert('비밀번호가 일치하지 않습니다.');
        return;
      }

      try {
        const res = await this.$axios.post('/api/auth/register', this.form);
        if (res.data.status === 'success') {
          alert('사용자 등록이 완료되었습니다.');
          this.$router.push('/'); // 메인 화면으로 이동
        }
      } catch (error) {
        const errorMsg = error.response?.data?.message || '서버 연결 실패';
        alert('등록 실패: ' + errorMsg);
      }
    }
  }
}
</script>
